import { useState, useLayoutEffect } from "react";
import { throttle } from "lodash";

function getScroll(container, direction = "vertical") {
  let scrollPos = 0;

  if (container && container !== document.documentElement) {
    return direction === "vertical"
      ? container.scrollTop
      : container.scrollLeft;
  } else {
    if (document.documentElement && document.documentElement !== null) {
      scrollPos =
        direction === "vertical"
          ? document.documentElement.scrollTop
          : document.documentElement.scrollLeft;
    }
    return direction === "vertical"
      ? window.pageYOffset || scrollPos
      : window.pageXOffset || scrollPos;
  }
}

export default function useWindowScroll(
  container,
  direction = "vertical",
  throttleTime = 100
) {
  const [windowScroll, setWindowScroll] = useState(
    getScroll(container, direction)
  );

  useLayoutEffect(() => {
    const _container =
      container && container !== document.documentElement ? container : window;
    const throttledHandler = throttle(
      () => setWindowScroll(getScroll(container, direction)),
      throttleTime
    );
    _container.addEventListener("scroll", throttledHandler);
    return () => _container.removeEventListener("scroll", throttledHandler);
  }, [container, direction, throttleTime]);

  return windowScroll;
}
